import React, {Fragment, useState} from 'react';
import RootHeader from "../../../layout/root/header";
import {useGetAwardsRace} from "../api/award";
import {theme} from "../gamification/_section/RewardSystem";
import {AwardRaceCard} from "./_section/AwardRaceCard";
import LoadMore from "../../../core/components/loadmore";
import RenderIf from "../../../core/components/render-if";

function RaceAwardsPage(props) {
    const [type, setType] = useState('user')
    const {
        data: awardsRaceData,
        hasNextPage,
        isFetchingNextPage,
        fetchNextPage,
        refetch
    } = useGetAwardsRace({type: type});

    const hasData = awardsRaceData?.pages?.some(page => page.data?.length > 0);
    return (
        <>
            <RootHeader title={'برترین‌ها'} haveHumberMenu navigateTo={'/app/awards'}/>
            <div
                className="min-h-screen pb-10 pt-16 px-4"
                style={{
                    background: `linear-gradient(160deg,#0a0612 0%,${theme.deep} 45%,#0a0612 100%)`
                }}
            >
            <div className="mb-6 flex flex-col gap-3">

                <div
                    className="inline-flex p-1 rounded-2xl w-fit"
                    style={{
                        background: `${theme.primary}22`,
                        border: `1px solid ${theme.light}22`
                    }}
                >
                    {[
                        {
                            key: "user",
                            title: "فردی"
                        },
                        {
                            key: "team",
                            title: "تیمی"
                        }
                    ].map(item => (
                        <button
                            key={item.key}
                            onClick={() => setType(item.key)}
                            className="px-5 py-2 rounded-xl text-sm font-bold transition-all duration-300"
                            style={{
                                background:
                                    type === item.key
                                        ? `linear-gradient(135deg, ${theme.primary}, ${theme.accent})`
                                        : "transparent",

                                color:
                                    type === item.key
                                        ? "#fff"
                                        : theme.light,

                                boxShadow:
                                    type === item.key
                                        ? `0 0 20px ${theme.accent}44`
                                        : "none"
                            }}
                        >
                            {item.title}
                        </button>
                    ))}
                </div>
            </div>
                <div className="mt-8 space-y-5">
                    <RenderIf cond={!hasData}>
                        <div
                            className="rounded-2xl p-8 text-center"
                            style={{
                                background: `${theme.primary}11`,
                                border: `1px solid ${theme.light}22`,
                                color: theme.light,
                            }}
                        >
                            <div className="text-5xl mb-3">🏆</div>
                            <h3 className="text-lg font-bold text-white mb-2">
                                هنوز کسی جایزه‌ای دریافت نکرده
                            </h3>
                            <p className="text-sm opacity-80">
                                به محض اینکه اولین جایزه ثبت بشه، اینجا نمایش داده میشه.
                            </p>
                        </div>
                    </RenderIf>
                    {awardsRaceData?.pages?.map((group, pageIndex) => (
                        <Fragment key={`awards-page-${pageIndex}`}>
                            {group.data.map((item) => (
                                <AwardRaceCard
                                    key={item.id}
                                    item={item}
                                />
                            ))}
                        </Fragment>
                    ))}

                    <LoadMore
                        auto
                        fetchNextPage={fetchNextPage}
                        hasNextPage={hasNextPage === true}
                        isFetchingNextPage={isFetchingNextPage}
                    />
                </div>
            </div>
        </>
    );
}

export default RaceAwardsPage;